import { createSlice } from '@reduxjs/toolkit';

import {
    fetchEmailLists,
    subscribeToEmailList,
    unsubscribeToEmailList,
} from '@/redux/modules/account/notifications/emailList/emailList.actions';
import {
    defaultEmailListSlice,
    EmailList,
    SUBSCRIBE_TO_ALL_EMAIL_LISTS,
    UNSUBSCRIBE_TO_ALL_EMAIL_LISTS,
} from '@/redux/modules/account/notifications/emailList/emailList.types';

const emailListSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchEmailLists.pending, (slice) => {
            slice.loading = true;
        });
        builder.addCase(fetchEmailLists.fulfilled, (slice, { payload }) => {
            slice.lists = payload;
            slice.loaded = Date.now();
            slice.loading = false;
        });
        builder.addCase(fetchEmailLists.rejected, (slice) => {
            slice.loading = false;
        });

        builder.addCase(subscribeToEmailList.fulfilled, (slice, { meta }) => {
            let lists: EmailList[];
            if (meta.arg === SUBSCRIBE_TO_ALL_EMAIL_LISTS) {
                lists = slice.lists.map((list) => ({
                    ...list,
                    subscribed: true,
                }));
            } else {
                lists = slice.lists.map((list) => ({
                    ...list,
                    subscribed: list.code === meta.arg ? true : list.subscribed,
                }));
            }
            slice.lists = lists;
        });

        builder.addCase(unsubscribeToEmailList.fulfilled, (slice, { meta }) => {
            let lists: EmailList[];
            if (meta.arg.code === UNSUBSCRIBE_TO_ALL_EMAIL_LISTS) {
                lists = slice.lists.map((list) => ({
                    ...list,
                    subscribed: false,
                }));
            } else {
                lists = slice.lists.map((list) => ({
                    ...list,
                    subscribed: list.code === meta.arg.code ? false : list.subscribed,
                }));
            }
            slice.lists = lists;
        });
    },
    initialState: defaultEmailListSlice,
    name: 'emailList',
    reducers: {},
});

export const { reducer: emailListReducer } = emailListSlice;
